/* eslint-disable camelcase */
import { Fragment, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Navbar, Nav } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { setUserRole } from 'src/redux/modules/authentication';
import { Typography } from 'src/latest/src/components';
import { ProfileAvatarDropdown } from './ProfileAvatarDropdown';
import { booleanFlagValue, UserRoles } from '../../constants';
import { HeaderLinksText } from './Constants';

type Props = {
  handleNav: (path: string) => void;
};

export const AuthenticatedUserHeaderContent = ({ handleNav }: Props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loggedInUser = useSelector(
    (state: any) => state?.authentication?.loggedInUser,
  );
  const isDirectory = useSelector(
    (state: any) => state.configuration.isDirectoryPlatform,
  );
  const { user_type } = loggedInUser;
  const configuration = useSelector((state: any) => state.configuration);
  const isDirectoryPlatform = isDirectory === 'true';

  // this is my static addition from frontend for user type.
  const updatedUserType =
    configuration?.billingDashboardEnabled === booleanFlagValue.TRUE
      ? user_type?.some((role: any) =>
          [
            UserRoles.SCHEDULER,
            UserRoles.PRACTICE_ADMIN,
            UserRoles.TENANT_SUPER_ADMIN,
          ].includes(role),
        )
        ? Array.from(new Set([...user_type, UserRoles.BILLING]))
        : user_type
      : user_type;
  // end here

  const [activeType, setActiveType] = useState('');

  const userTypes =
    updatedUserType?.length > 1 ||
    updatedUserType?.includes(UserRoles.PRACTICE_ADMIN)
      ? [
          UserRoles.THERAPIST,
          UserRoles.SCHEDULER,
          UserRoles.PRACTICE_ADMIN,
          UserRoles.TENANT_SUPER_ADMIN,
          UserRoles.BILLING,
        ].reduce((acc: string[], role: string) => {
          if (updatedUserType?.includes(role)) {
            if (
              role === UserRoles.PRACTICE_ADMIN &&
              !updatedUserType?.includes(UserRoles.SCHEDULER)
            ) {
              acc.push(UserRoles.SCHEDULER);
            }

            acc.push(role);
          }

          return acc;
        }, [])
      : [];

  const getActiveTab = (currentActivePath: string) => {
    if (!currentActivePath) {
      setActiveType('');

      return;
    }

    switch (true) {
      case currentActivePath.includes('/therapy/scheduler'):
        setActiveType(UserRoles.SCHEDULER);
        break;
      case currentActivePath.includes('/practice-admin'):
        setActiveType(UserRoles.PRACTICE_ADMIN);
        break;
      case currentActivePath.includes('/therapy/therapist'):
        setActiveType(UserRoles.THERAPIST);
        break;
      case currentActivePath.includes('/super-admin'):
        setActiveType(UserRoles.TENANT_SUPER_ADMIN);
        break;
      case currentActivePath.includes('/billing-admin'):
        setActiveType(UserRoles.BILLING);
        break;
      default:
        setActiveType('');
    }
  };

  useEffect(() => {
    getActiveTab(window.location.pathname);
  }, [window.location.pathname]);

  const handleSwitchRole = async (role: string) => {
    // also persists the role, so a reload lands back in it
    await dispatch(setUserRole(role));

    const _role = role?.toLowerCase();

    if (role === UserRoles.TENANT_SUPER_ADMIN) {
      navigate(`/super-admin/home`);
    } else if (role === UserRoles.PRACTICE_ADMIN) {
      navigate(`/practice-admin/users`);
    } else if (role === UserRoles.BILLING) {
      navigate(`/billing-admin/home`);
    } else {
      navigate(`/therapy/${_role}`);
    }
  };

  return (
    <>
      <Fragment>
        {userTypes.length > 0 && (
          <Navbar.Toggle aria-controls="questionnaire-header" className="ms-auto border-0 me-3">
            {[...Array(3)].map((_, i) => (
              <span key={i} className="menu-stripped" />
            ))}
          </Navbar.Toggle>
        )}
        <div className="d-lg-none d-flex align-items-center">
             <ProfileAvatarDropdown
                isDirectoryPlatform={isDirectoryPlatform}
                onLogout={() => handleNav('/logout')}
             />
        </div>
        <Navbar.Collapse id="questionnaire-header">
          <Nav className="ms-auto align-items-center">
            <div className="user-type-wrapper">
              {(userTypes || []).length > 0 &&
                userTypes?.map((type: string, i: number) => (
                  <Typography
                    key={i}
                    onClick={() => {
                      handleSwitchRole(type);
                      setActiveType(type);
                    }}
                    className={`navigation-links ${
                      type === activeType ? 'active' : ''
                    }`}
                    weight="semi-bold"
                    color={`${type === activeType ? 'color-39' : 'color-38'}`}
                    variant="size-16"
                  >
                    {HeaderLinksText[type]}
                  </Typography>
                ))}
            </div>
            <div className="d-none d-lg-block">
                <ProfileAvatarDropdown
                isDirectoryPlatform={isDirectoryPlatform}
                onLogout={() => handleNav('/logout')}
                />
            </div>
          </Nav>
        </Navbar.Collapse>
      </Fragment>
    </>
  );
};
